import n from "./index277.js";
import { createElementBlock as s, openBlock as t, createElementVNode as r, createCommentVNode as a, normalizeClass as l, renderSlot as i, toDisplayString as u } from "vue";
/* empty css         */
import f from "./index231.js";
const c = ["data-component"], m = { class: "relative flex items-center vertical-padding" }, p = ["id", "name", "checked", "disabled"], b = ["for"], g = {
  key: 0,
  class: "text-color-alert-negative-100",
  "data-test-id": "error"
};
function h(e, o, v, k, w, y) {
  return t(), s("div", {
    "data-component": e.$options.name
  }, [
    r("div", m, [
      r("input", {
        id: e.finalId,
        type: "radio",
        class: "absolute cursor-pointer inset-0 w-full h-full disabled:cursor-not-allowed input",
        name: e.name,
        checked: e.checked,
        disabled: e.isDisabled,
        onChange: o[0] || (o[0] = (...d) => e.onChange && e.onChange(...d))
      }, null, 40, p),
      r("div", {
        class: l(["flex self-start shrink-0 items-center justify-center w-24 h-24 mr-16 border border-solid rounded-full border-color-neutral-grey-20 checkbox", {
          "!border-color-alert-negative-100": (e.showError || e.errorMsg) && !e.isDisabled,
          "!border-color-neutral-grey-10": e.isDisabled
        }])
      }, o[1] || (o[1] = [
        r("div", { class: "w-16 h-16 rounded-full dot" }, null, -1)
      ]), 2),
      r("label", {
        class: l(["text-text-l", {
          "text-color-alert-negative-100": (e.showError || e.errorMsg) && !e.isDisabled,
          "text-color-neutral-grey-20 cursor-not-allowed": e.isDisabled
        }]),
        for: e.finalId
      }, [
        i(e.$slots, "default", {}, void 0, !0)
      ], 10, b)
    ]),
    e.errorMsg ? (t(), s("div", g, u(e.errorMsg), 1)) : a("", !0)
  ], 8, c);
}
const M = /* @__PURE__ */ f(n, [["render", h], ["__scopeId", "data-v-3898f3fc"]]);
export {
  M as default
};
